import Config from '@/config';
 import http from '@/http';

export interface UserInfo {
  userId: string | 0;
  realName: string;
  avatar: {
    avatar_small: string;
  };
  userPhoto:string;
}
function syncCenter(callback) {
  debugger
  console.log("333")
  if (!window.SSO) {
    console.log("444")
    return
  }
  const syncUrl =
    // window.SSO.SSOServerUrl +
    // '/login?service=' +
    // encodeURIComponent(window.Url.addParams({ isAjax: 'true' }, location.origin + location.pathname)) +
    // // encodeURIComponent(window.Url.addParams({ isAjax: 'true' }, window.SSO.loginRedirectUrl)) +
    // '&redirect=true'
    window.SSO.SSOServerUrl+
    '/login?service=' +
    encodeURIComponent( Config.getHost() +'/?isAjax=true') +
    // encodeURIComponent(window.Url.addParams({ isAjax: 'true' }, window.SSO.loginRedirectUrl)) +
    '&redirect=true';
    
  jQuery.ajax({
    url: syncUrl,
    type: 'GET',
    dataType: 'jsonp',
    jsonp: 'callback',
    crossDomain: true,
    cache: false,
    error(e) {
      console.log(e)
    },
    complete: function() {
      callback && callback()
    },
  })
}
const LoginHelper = {
  isLogin: false,
  getUser(){ 
    console.log("222")
    return new Promise<UserInfo> ((resolve, reject) =>{
      // 先从中心同步一下登录状态
      syncCenter(() => {
       // 获取登录状态
       console.log("555")
       window.SSO.getLoginState((resultObj) => {
         console.log(resultObj)
         if (resultObj.result === 'success') {
          console.log("666")
           // 获取token,userId
           window.SSO.getAccessToken((res2) => {
            console.log("777")
             console.log(res2)
             if (res2.result === 'success') {
              console.log("888")
               const { token, userId, loginName } = res2.data;

               http
                 .get('/login-registration/login/getUserProfile', {
                   params: {},
                   headers: {
                     token,
                     appkey: window.SSO.appKey,
                     clientType: window.SSO.client,
                     deviceId: window.SSO.deviceId,
                   },
                 })
                 .then((res) => {
                  const { code, data } = res.data;
                   debugger
                   
                  resolve(data)
                 })
             }
           })
         }
       })
     })
   // return http
   //   .get('/EduResource/index.php', {
   //     params: {
   //       app: 'resource',
   //       mod: 'Homepage',
   //       act: 'getUserProfile',
   //     },
   //   })
   //   .then((res) => {
   //     const { code, data } = res.data;

   //     if (code === 200) {
   //       return data;
   //     }
   //   });
 })
  }
};

export default LoginHelper;
